import { render } from "./tagluffaieuropa_logo.vue?vue&type=template&id=b6ba67d2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__